export class FaciesEcoulement {

    id: number; // For IndexedDB
    interventionId: number;
    
    ChenalLentique: boolean;
    FosseDissipation: boolean;
    FosseDaffouillement: boolean;
    MouilleConcavite: boolean;
    ChenalLotique: boolean;
    PlatLentique: boolean;
    PlatCourant: boolean;
    Radier: boolean;
    Rapide: boolean;
    Cascade: boolean;
    Chute: boolean;
    BancConvexite: boolean;
    Escalier: boolean;
    EauMorteLone: boolean;
    LentiqueIndetermine: boolean;
    LotiqueIndetermine: boolean;
    SousBerge: boolean;
    ZoneDeBordure: boolean;

    static mapFromJSON(json: any): FaciesEcoulement {
        const m = new FaciesEcoulement();

        m.ChenalLentique = json.chenalLentique;
        m.FosseDissipation = json.fosseDissipation;
        m.FosseDaffouillement = json.fosseAffouillement;
        m.MouilleConcavite = json.mouilleConcavite;
        m.ChenalLotique = json.chenalLotique;
        m.PlatLentique = json.platLentique;
        m.PlatCourant = json.platCourant;
        m.Radier = json.radier;
        m.Rapide = json.rapide;
        m.Cascade = json.cascade;
        m.Chute = json.chute;
        m.BancConvexite = json.bancConvexite;
        m.Escalier = json.escalier;
        m.EauMorteLone = json.eauMorteLone;
        m.LentiqueIndetermine = json.lentiqueIndetermine;
        m.LotiqueIndetermine = json.lotiqueIndetermine;
        m.SousBerge = json.sousBerge;
        m.ZoneDeBordure = json.zoneDeBordure;

        return m;
    }
}
